export default __webpack_public_path__ + "static/media/aproval_matrix.758564bb.png";